<template>
  <div class="app" :class="classes">
    <AppHeader
      :user="$store.state.user"
      @mobileMenuToggle="showMobileMenu = !showMobileMenu"
      hasSidebar
    />

    <div class="app-body">
      <AppSidebar v-if="user.id" />

      <main class="main">
        <SubHeader v-if="user.id" :user="user" />

        <div
          :class="{
            container: $route.meta.container !== false,
            'py-5': !user.id
          }"
          class="flex-grow-1"
        >
          <RouterView />
        </div>
      </main>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import {
  Header as AppHeader,
  Footer as AppFooter,
  Sidebar as AppSidebar,
  SubHeader
} from "@/components/";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppSidebar,
    SubHeader
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    classes() {
      return {
        // "sidebar-fixed": !!this.$store.state.user.details,
        "sidebar-mobile-show": this.showMobileMenu
      };
    }
  },

  data: () => ({
    showMobileMenu: false
  }),

  watch: {
    "$route.fullPath": {
      handler() {
        this.showMobileMenu = false;
      }
    }
  }
};
</script>
